"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@/components");
var _lodash = _interopRequireDefault(require("lodash"));
var _servicesListMixin = require("@/mixins/servicesListMixin");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = {
  name: 'ProductsServices',
  bodyClass: 'products-services-page',
  components: {
    CardMonitor: _components.CardMonitor,
    FieldSearchInput: _components.FieldSearchInput
  },
  mixins: [_servicesListMixin.servicesListMixin],
  data: function data() {
    return {
      activeTab: 0,
      filter: ''
    };
  },
  computed: {
    servicesHealthys: function servicesHealthys() {
      var items = this.listServicesOrder.filter(function (i) {
        return i.active === true;
      });
      return items.length;
    },
    servicesCriticals: function servicesCriticals() {
      var items = this.listServicesOrder.filter(function (i) {
        return i.active === false;
      });
      return items.length;
    },
    listServicesOrder: function listServicesOrder() {
      return _lodash.default.orderBy(this.listServices, ['name']);
    },
    list: function list() {
      var _this = this;
      if (this.filter.length) {
        return this.listServicesOrder.filter(function (p) {
          return p.name.toUpperCase().indexOf(_this.filter.toUpperCase()) >= 0;
        });
      }
      return this.listServicesOrder;
    }
  },
  methods: {
    openDetailService: function openDetailService(item) {
      this.$router.push({
        path: "/service-detail-extract/".concat(item._id)
      });
    }
  }
};